import axiosInstance from 'utils/axiosInstance';
import {
  AssignInfo,
  ImportSoftware,
  SoftwareDetails,
  SoftwareFilter,
  SoftwareHistory,
  SoftwareInfo,
  SoftwareResponse,
  SoftwareType,
} from '../types/softwareTypes';

export const getSoftware = async (filters: SoftwareFilter) => {
  const { data } = await axiosInstance.post<ApiResponse<SoftwareResponse>>(
    'api/software/List',
    filters,
  );
  return data;
};

export const createSoftware = async (formData: FormData) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/software/Create',
    formData,
  );
  return data;
};

export const editSoftware = async (formData: FormData) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/software/Update',
    formData,
  );
  return data;
};

export const getFormData = async () => {
  const { data } = await axiosInstance.get<ApiResponse<SoftwareDetails>>(
    'api/software/createformdata',
  );
  return data;
};

export const getSoftwareTypes = async () => {
  const { data } = await axiosInstance.get<ApiResponse<SoftwareType>>(
    'api/software/dataIndex',
  );
  return data;
};

export const getSoftwareById = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<SoftwareDetails>>(
    `api/software/GetById/${id}`,
  );
  return data;
};

export const getSoftwareHistory = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<SoftwareHistory[]>>(
    `api/software/History/${id}`,
  );
  return data;
};

export const getAffectedHistorySoftware = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<SoftwareHistory[]>>(
    `api/software/AffectSoftwareHistory/${id}`,
  );
  return data;
};

export const assignSoftwareToUser = async (software: AssignInfo) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/software/AssignedTo',
    software,
  );
  return data;
};

export const getAssignedSoftware = async (info: SoftwareInfo) => {
  const { data } = await axiosInstance.post<
    ApiResponse<{ id: string; text: string }[]>
  >('api/software/GetUsers', info);
  return data;
};

export const unassignSoftwareUser = async (info: {
  id: number;
  user: string;
}) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/software/UnassignProfile',
    info,
  );
  return data;
};

export const getSoftwares = async () => {
  const { data } = await axiosInstance.get<
    ApiResponse<{ id: string; text: string }[]>
  >('api/software/SelectItems');
  return data;
};

export const uploadSoftwareFile = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await axiosInstance.post<ApiResponse<string>>(
    'api/software/Upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return data;
};

export const addSoftwareExcelData = async (hardwares: ImportSoftware[]) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/software/AddExcelData',
    hardwares,
  );
  return data;
};

export const downloadSoftwareTemplate = async () => {
  const { data } = await axiosInstance.get<ArrayBuffer>(
    'api/software/Download',
    {
      responseType: 'arraybuffer',
    },
  );
  return data;
};

export const deleteSoftwareFile = async (fileId: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `api/software/deletefile/${fileId}`,
  );
  return data;
};
